import { MinimalAudioSkinElement } from '../../presets/audio/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/minimal-audio/register';

safeDefine(MinimalAudioSkinElement);
